import React from 'react';
import { useTrackSection } from '../utils/useTrackSection';
export function Guarantee() {
  useTrackSection('guarantee', 'Guarantee Section');
  return <section id="guarantee" className="w-full px-4 sm:px-6 lg:px-8 py-8 text-gray-900" style={{
    background: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(240,253,244) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-177">
      <div className="mx-auto max-w-3xl" data-id="element-178">
        <div className="rounded-2xl overflow-hidden shadow-sm" style={{
        border: '1px solid rgba(34,197,94,0.3)'
      }} data-id="element-179">
          {/* Header */}
          <div className="px-6 py-4 flex items-center justify-center gap-3" style={{
          background: 'linear-gradient(135deg, #16a34a, #15803d)'
        }} data-id="element-180">
            <span className="text-3xl" data-id="element-181">🛡️</span>
            <h2 className="text-lg sm:text-xl font-black text-white m-0" data-id="element-182">
              GARANTÍA MEGAPACK™ — 7 DÍAS
            </h2>
          </div>

          {/* Body */}
          <div className="px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-4" style={{
          backgroundColor: 'rgb(240,253,244)'
        }} data-id="element-183">
            <p className="text-sm text-gray-600 m-0 text-center sm:text-left" data-id="element-184">
              Abrís los 6 tomos. Revisás los 6 bonos.
              <br data-id="element-185" />
              Si en 7 días no es lo que esperabas:
            </p>

            <div className="text-center shrink-0" data-id="element-186">
              <p className="text-2xl font-black m-0" style={{
              color: '#16a34a'
            }} data-id="element-187">
                Te devolvemos el 100%
              </p>
              <p className="text-xs font-black text-gray-700 m-0" data-id="element-188">
                Sin preguntas · Sin formularios · Sin drama
              </p>
            </div>
          </div>

          {/* Footer */}
          <div className="px-6 py-3 text-center border-t" style={{
          borderColor: 'rgba(34,197,94,0.15)'
        }} data-id="element-189">
            <p className="text-xs text-gray-500 m-0" data-id="element-190">
              +500 profesionales ya lo compraron · Tasa de devolución menor al
              1%
            </p>
          </div>
        </div>
      </div>
    </section>;
}